/**
 * El mensaje legible de un error de la API, para mostrarlo al lado de la
 * acción que falló.
 *
 * El server manda `{ error: { message } }` (y algunos endpoints viejos
 * `{ message }`); si no hay nada de eso —caída de red, 502 de Kong— va el
 * `fallback`, que conviene que diga QUÉ no se pudo hacer ("No se pudo
 * eliminar la organización") y no un genérico.
 */
export function mensajeDeError(e: unknown, fallback = 'Ocurrió un error.'): string {
  const resp = (e as { response?: { data?: { message?: string; error?: { message?: string } } } })
    ?.response;
  return resp?.data?.error?.message ?? resp?.data?.message ?? fallback;
}
